module.exports = __webpack_public_path__ + "static/crissxcross.3d36c210.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg/crissxcross.png
// module id = 190
// module chunks = 213534597649335 220753811298009